import { ComparateurFunnel } from '../../../components/tools/ComparateurFunnel';
import { AudienceToolHero } from '../../../components/blocks/AudienceToolHero';
import { getAudienceToolContent } from '../../../config/audience-tool-content';
import { BreadcrumbListLd } from '../../../components/seo/jsonld/BreadcrumbList';

const content = getAudienceToolContent('tertiaire', 'comparateur-energie')!;

export default function TertiaireComparateurEnergiePage() {
  return (
    <>
      <AudienceToolHero
        content={content}
        backHref="/tertiaire"
        backLabel="Espace tertiaire"
        duration="3 min"
      >
        <ComparateurFunnel lockedAudience="tertiaire" />
      </AudienceToolHero>

      <BreadcrumbListLd
        items={[
          { name: 'Accueil', url: 'https://solutionecofrance.fr/' },
          { name: 'Espace tertiaire', url: 'https://solutionecofrance.fr/tertiaire' },
          { name: 'Comparateur énergie', url: 'https://solutionecofrance.fr/tertiaire/comparateur-energie' },
        ]}
      />
    </>
  );
}
